import { Box, Button, CardMedia, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { eventData } from "../../../../../data";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useSelector, useDispatch } from "react-redux";
import { ComponentType, EntityType } from "../../../../../common/enum";
import MapLeaflet from "../../../../MapLeaflet";
import { getParticularDonationById } from "../../../slice";
import {UpdatePedidoAlteracao , UpdateDateCollection} from "../../../../CreateCollection/slice"
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import dayjs from "dayjs";
import "dayjs/locale/pt";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import {
  getDonationById,
  getDonationEntityDetailById,
  getReceiverDetailById,
} from "../../../../MessagePanel/slice";
import { useSnackbar } from "notistack";
import {
  setStartDate,
  setUpdateDonationDetail,
} from "../../../../DonationView/slice";

const Details = ({ component, donation, t, collection }) => {
  const {
    auth: {
      profile: { address, entity },
    },
    dashboardInfo: { entityProfileSelect },
    collection: {
      myCollections: { collectionDetails },
    },
    messageReducer: { chatDonationDetail, recevierEntityDetail },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const [drawerState, setDrawerState] = React.useState(false);
  const [donationId, setDonationId] = React.useState("");
  const [donationUid, setDonationUid] = React.useState("");
  const [note, setNote] = React.useState("");
  const [collectionDetail, setCollectionDetail] = React.useState({});
  const [position, setPosition] = React.useState(null);
  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dispatch = new useDispatch();
  const [errorDate, setErrorDate] = React.useState(false);
  const [errorStartDate, setErrorStartDate] = React.useState(false);
  const [reasonStartDate, setReasonStartDate] = React.useState(" ");
  const [receptorDetail, setReceptorDetail] = React.useState();
 
  const [startDateValue, setStartDateValue] = React.useState(null);
  const [dateWithInitialValue, setDateWithInitialValue] = React.useState(null);
  const [currentError, setCurrentError] = React.useState(null);
  const [donationDetail, setdonationDetail] = React.useState(null);
  const setMarkPosition = (value) => {
    setPosition(value);
  };

  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }


  React.useEffect(() => {
    if (collection) {
      dispatch(getParticularDonationById(collection?.collection?.donationId))
        .unwrap()
        .then((res) => {
          const id = res?.donations?.donation.id;
          const year = new Date(
            res?.donations?.donation.createdDate
          ).getFullYear();
          setDonationUid(`${year}${id}`);
        }).catch((err) => {
          console.error(err);
        });
    }
  }, [collection]);

  React.useEffect(() => {
    if (ComponentType.DONATION === component) {
      if (donation?.donation !== undefined) {
        const { donationId, note, createdDate, id } = donation.donation;
        const detailDonationId = `${new Date(createdDate).getFullYear()}${id}`;
        setDonationId(detailDonationId);
        // setDonationId(donationId.slice(0, 1) + donationId.slentityice(10, 14));
        setNote(note);
      }
    } else if (ComponentType.AGENDA === component) {
      if (collection !== undefined) {
        setCollectionDetail(collection);
        if (collectionDetail?.collection !== undefined) {
          const id = `${new Date(
            collectionDetail?.collection?.createdDate
          ).getFullYear()}${collectionDetail?.collection?.id}`;
          // collectionDetail?.collection?.donationId.slice(0, 1) +
          // collectionDetail?.collection?.donationId.slice(10, 14);
          setDonationId(id || "");
        }
        setNote(collectionDetail?.colllection?.note || "");
      }
    }
    return () => {
      setDonationId("");
      setNote("");
    };
  }, [component, donation, collection, collectionDetail]);
  
  React.useEffect(() => {
    let payload = {};
    if (collection !== undefined && Object.keys(collection).length > 0) {
      payload["donationId"] = collection?.collection?.donationId;
    }
    if (Object.keys(payload).length > 0) {
      dispatch(getDonationById(payload))
        .unwrap()
        .then((res) => {
          dispatch(
            getDonationEntityDetailById({
              entityId: res.donationId.donations.donation.entityId,
            })
          );
          setdonationDetail(res)
         // console.log("testDonation" ,donationDetail, res)
         // console.log(res)
          let entityPayload = {};
        
            entityPayload["entityId"] =collection?.collection.collectorId;
          
            getReceiverDetailById(entityPayload);
           
           // console.log(recevierEntityDetail)
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }, [dispatch, collection]);

  const [open, setOpen] = React.useState(false);

  const AlterarPedidoHandle = React.useCallback(() => {
    setOpen(true);
  }, []);
  
  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);
  
  const startHandleChange = (newValue) => {
    setStartDateValue(newValue);
    if (!Number.isNaN(new Date(newValue).getTime()) && newValue !== null) {
      const payload = {
        ...updateDonationDetail,
        availableFromDate: toLocalISOString(newValue),
      };
      dispatch(setUpdateDonationDetail(payload));
      dispatch(setStartDate(false));
    }
  };
  React.useEffect(() => {
    let payload = {};
    if (collection !== undefined && Object.keys(collection).length > 0) {
      payload["donationId"] = collection?.collection?.donationId;
    }
    if (Object.keys(payload).length > 0) {
      dispatch(getDonationById(payload))
        .unwrap()
        .then((res) => {
          dispatch(
            getDonationEntityDetailById({
              entityId: res.donationId.donations.donation.entityId,
            })
          );
          //console.log(res)
          let entityPayload = {};
        
            entityPayload["entityId"] =collection?.collection.collectorId;
          
            getReceiverDetailById(entityPayload);
           
            //console.log(recevierEntityDetail)
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }, [dispatch, collection]);


  const SolicitarAlteracao = React.useCallback(async () => {
   
    await new Promise(resolve => setTimeout(resolve, 0));
  
    dispatch(UpdatePedidoAlteracao(collectionDetail && collection?.collection.id))
      enqueueSnackbar({
        message: 'Pedido de solicitação enviado com sucesso',
        variant: "success",
      });
    
  }, [collectionDetail, collection, dispatch]);

  // const onConfirm = React.useCallback(() => {
    
  //   const data = {
  //     id: collection?.collection.id,
  //     dateOfCollection: dateWithInitialValue
  //   };
  //   dispatch(UpdateDateCollection(data))
  //     .unwrap()
  //     .then((res) => {
  //       dispatch(setDrawerState(false));
  //       enqueueSnackbar({
  //         message: t("successfullyApproved"),
  //         variant: "success",
  //       });
  //     })
  //     .catch((error) => {
  //       enqueueSnackbar({
  //         message: t("somethingWentWrong"),
  //         variant: "error",
  //       });
  //     });
  // }, []);
  const onConfirm = React.useCallback(async () => {
    const data = {
      id: collection?.collection.id,
      dateOfCollection: dateWithInitialValue
    };
  
    await new Promise(resolve => setTimeout(resolve, 0)); 
  
    try {
      const res = await dispatch(UpdateDateCollection(data)).unwrap();
      if(res.obj == true){
        enqueueSnackbar({
          message: 'Alteração bem sucedida',
          variant: "success",
        });
        window.location.reload();
      }else{
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      }
     
    } catch (error) {
    
    }
  }, [collection, dateWithInitialValue, dispatch, enqueueSnackbar, t]);

  return (
    <Box>
      <Stack direction="column" gap="6px" pb={4}>
        <Typography
          variant="h6"
          color={"text.secondary"}
          // sx={{ textTransform: "capitalize" }}
          fontWeight={600}
        >
          {t("code")}
        </Typography>
        <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
          {donationUid ? donationUid : ""}
        </Typography>
      </Stack>
      <Stack direction="column" gap="6px" pb={4}>
        <Typography variant="h6" color={"text.secondary"} fontWeight={600}>
          {t("reservationCode")}
        </Typography>
        <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
          {donationId ? donationId : ""}
        </Typography>
      </Stack>
      <Stack direction="column" gap="6px" pb={4}>
        <Typography variant="h6" color={"text.secondary"} fontWeight={600}>
          {Object.keys(collectionDetail).length > 0 && collectionDetail?.obj && collectionDetail?.obj.collectionType == "donated" ? 'Recetor' : 'Doador' }
        </Typography>
        <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
          {/* {collectionDetail?.entity ? collectionDetail.entity.entityType === 'DONOR' ? collectionDetail.entity.entityName  : collectionDetail?.addresses ? collectionDetail?.addresses[0].addressTitle : "" :  collectionDetail?.addresses ? collectionDetail?.addresses[0].addressTitle : ""} */}
          {   Object.keys(collectionDetail).length > 0 && collectionDetail?.obj && collectionDetail?.obj.collectionType == "donated"  && collectionDetail?.entity != null?
              Object.keys(recevierEntityDetail).length > 0 &&   recevierEntityDetail?.address[0].isHeadquarter == true ? 
              Object.keys(recevierEntityDetail).length > 0 && recevierEntityDetail?.entity.entityName :
              Object.keys(recevierEntityDetail).length > 0 &&  recevierEntityDetail?.entity.entityName : 
              collectionDetail?.addresses ?  
              collectionDetail?.addresses[0].isHeadquarter == true && collectionDetail?.entity != null? 
              collectionDetail?.entity.entityName :  
              collectionDetail  && collectionDetail?.entity != null? 
              collectionDetail?.entity.entityName : recevierEntityDetail?.entity.entityName : "" }
       
          
        </Typography>
      </Stack>
      <Stack direction="column" gap="6px" pb={4}>
        <Typography variant="h6" color={"text.secondary"}>
          {component === ComponentType.DONATION
            ? "Periodo de recolha"
            : "Recolha"}
        </Typography>
        <Typography variant="h6" fontWeight={600}>
          {component === ComponentType.AGENDA && (
            <Typography variant="body1">
              {collectionDetail?.collection !== undefined
                ? new Date(
                    collectionDetail?.collection?.dateOfCollection
                  ).toLocaleString("pt", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                    timeZone: currentTimeZone,
                  })
                : ""}
            </Typography>
          )}
        </Typography>
        {component === ComponentType.DONATION &&
          Object.keys(donation).length > 0 && (
            // <Stack mt={2} direction={"column"} gap={1}>
            //   <Stack
            //     direction={"row"}
            //     alignItems="center"
            //     justifyContent={"space-between"}
            //     width={1}
            //   >
            //     <Typography variant="h6" fontWeight={600}>
            //       {t("startDate")}
            //     </Typography>
            //     <Typography variant="body1">
            //       {new Date(
            //         donation?.donation?.availableFromDate + "Z"
            //       ).toLocaleString("pt-PT", {
            //         day: "numeric",
            //         month: "numeric",
            //         year: "numeric",
            //         hour: "numeric",
            //         minute: "numeric",
            //         formatMatcher: "best fit",
            //         timeZone: currentTimeZone,
            //       })}
            //     </Typography>
            //   </Stack>
              
            //   <Stack
            //     direction={"row"}
            //     alignItems="center"
            //     justifyContent={"space-between"}
            //     width={1}
            //   >
            //     <Typography variant="h6" fontWeight={600}>
            //       {t("endDate")}
            //     </Typography>
            //     <Typography variant="body1">
            //       {new Date(
            //         donation?.donation?.expiryDate 
            //       ).toLocaleString("pt-PT", {
            //         day: "numeric",
            //         month: "numeric",
            //         year: "numeric",
            //         hour: "numeric",
            //         minute: "numeric",
            //         formatMatcher: "best fit",
            //         timeZone: currentTimeZone,
            //       })}
            //     </Typography>
            //   </Stack>
            // </Stack>
            // ////
            // &&
            <Box sx={{ width: 1, display: "flex", alignItems: "center" }}>
            <CalendarMonthOutlinedIcon />
            <Typography
              variant="body2"
              sx={{ ml: 2 }}
              textTransform={"capitalize"}
            >
              {t("in")}{" "}
              <span>
              {new Date(
                    donation?.donation?.availableFromDate
                  ).toLocaleString("pt-PT", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                    timeZone: currentTimeZone,
                  })}
              </span>{" "}
              {t("until")}{" "}
              <span>
              {new Date(
                    donation?.donation?.expiryDate 
                  ).toLocaleString("pt-PT", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                    timeZone: currentTimeZone,
                  })}
              </span>
            </Typography>
          </Box>
          )}

          { entity?.entityType == "SPECIAL_DISTRIBUTOR" &&  Object.keys(collectionDetail).length > 0 && collectionDetail?.recetorEntity.id == entity.id && new Date(donationDetail?.donationId?.donations?.donation?.consumeByDate) > new Date() && collectionDetail?.collection?.status != "CANCELLED" && collectionDetail?.collection?.status != "COLLECTED" || entityProfileSelect == 'DISTRIBUTOR' &&  Object.keys(collectionDetail).length > 0 && collectionDetail?.recetorEntity.id == entity.id && new Date(donationDetail?.donationId?.donations?.donation?.expiryDate) > new Date() && collectionDetail?.collection?.status != "CANCELLED" && collectionDetail?.collection?.status != "COLLECTED" || entity?.entityType == 'DISTRIBUTOR' &&  Object.keys(collectionDetail).length > 0 && collectionDetail?.recetorEntity.id == entity.id && new Date(donationDetail?.donationId?.donations?.donation?.expiryDate) > new Date() && collectionDetail?.collection?.status != "CANCELLED" && collectionDetail?.collection?.status != "COLLECTED" ?
          <Button
          sx={{
            justifyContent: "left",
            fontWeight: 600,
            textDecoration: "underline",
            color: "#1c727e",
            p: "0px !important",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
            borderRadius:"4px"
          }}
          onClick={SolicitarAlteracao}
        >
          {"Solicitar alteração"}
        </Button>
           :   Object.keys(collectionDetail).length > 0 && collectionDetail?.entity?.id == entity.id ? 
           <Button
           disabled = {collectionDetail && !collectionDetail?.collection?.pedidoAlteracao}
           sx={{
            justifyContent: "left",
             fontWeight: 600,
             textDecoration: "underline",
             color: "#1c727e",
             p: "0px !important",
             "&:hover": {
               backgroundColor: "transparent",
               textDecoration: "underline",
             },
             borderRadius:"4px"
           }}
           onClick={AlterarPedidoHandle}
         >
           {"Alterar recolha"}
         </Button>
           : ''
          
        }
      </Stack>

      <Stack direction="column" gap="6px" pb={4}>
        <Typography variant="h6" color={"text.secondary"} fontWeight={600}>
          {t("pickupLocation")}
        </Typography>
        <Typography variant="body1">
          {component === ComponentType.AGENDA &&
          collectionDetail?.addresses !== undefined ? (
            <>
              {/* <Typography
                component="span"
                variant="body1"
              >
                {collectionDetail.addresses[0]?.latitude},
              </Typography>
              <br/> */}
              {/* <span style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                {collectionDetail?.entity?.entityName}
              </span>{" "}
              {collectionDetail?.addresses[0]?.addressTitle} <br />{" "} */}
              {collectionDetail?.addresses[0]?.addressLine} <br />{" "}
              {collectionDetail?.addresses[0]?.locality} <br />{" "}
              {collectionDetail?.addresses[0]?.county} <br />
              {collectionDetail?.addresses[0]?.district} <br />
              {collectionDetail?.addresses[0]?.postalCode}
              <br />
              <Typography
                color="primary"
                sx={{ textDecoration: "underline" }}
                component="span"
                variant="body1"
              >
                {collectionDetail.addresses[0]?.latitude},
                {collectionDetail.addresses[0]?.longitude}
              </Typography>
            </>
          ) : (
            ""
          )}
        </Typography>
        {component === ComponentType.AGENDA && (
          <Box sx={{ width: 1, height: 300 }}>
            <MapLeaflet
              isDirectionAble={
                entity?.entityType === EntityType.distributor ||
                entityProfileSelect === EntityType.distributor ||
                 entity?.entityType == 'SPECIAL_DISTRIBUTOR' ||
                  entityProfileSelect == 'SPECIAL_DISTRIBUTOR'
                  ? true
                  : false
              }
              isPin={
                entity?.entityType === EntityType.donor ||
                entityProfileSelect === EntityType.donor
                  ? false
                  : true
              }
              position={position}
              setPosition={setMarkPosition}
              sourceAddress={address[0]}
              destinationAdrress={
                collectionDetail?.addresses !== undefined &&
                collectionDetail.addresses[0]
              }
              t={t}
            />
          </Box>
        )}
        {component !== ComponentType.AGENDA &&
          donation?.addresses?.length > 0 && (
            <Stack mt={2} direction={"column"} gap={1}>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("addressTitle")}
                </Typography>
                <Typography variant="body1">
                  {donation?.addresses[0]?.addressTitle}
                </Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("houseHold")}
                </Typography>
                <Typography variant="body1">
                  {donation?.addresses[0]?.addressLine}
                </Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("district")}
                </Typography>
                <Typography>{donation?.addresses[0]?.district}</Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("county")}
                </Typography>
                <Typography>{donation?.addresses[0]?.county}</Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("parshi")}
                </Typography>
                <Typography>{donation?.addresses[0]?.subDivision}</Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("postalCode")}
                </Typography>
                <Typography>{donation?.addresses[0]?.postalCode}</Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography variant="h6">{t("locality")}</Typography>
                <Typography>{donation?.addresses[0]?.locality}</Typography>
              </Stack>
              <Stack
                direction={"column"}
                alignItems="flex-start"
                justifyContent={"space-between"}
              >
                <Typography
                  color="primary"
                  sx={{ textDecoration: "underline" }}
                  component="span"
                >
                  {donation?.addresses[0]?.latitude},
                  {donation?.addresses[0]?.longitude}
                </Typography>
              </Stack>
            </Stack>
          )}
        {/* <CardMediawTabs } from "../../../data.js";
import ActionCard from "./ActionCard/index.js";

const Actions = ({component, t ,collection,setCollectionId}) => <ActionCard
          component="img"
          height="300"
          image="https://developers.google.com/maps/images/landing/hero_geocoding_api.png"
        /> */}
      </Stack>
      <Stack direction="column" gap="6px" pb={4}>
        <Typography
          variant="h6"
          color={"text.secondary"}
          fontWeight={600}
          sx={{ textTransform: "capitalize" }}
        >
          {t("observations")}
        </Typography>
        <Typography variant="body1">
          {note ? note : "Sem observações"}
        </Typography>
      </Stack>
        
  <ConfirmDialog
          open={open}
          handleClose={handleClose}
          title={
           'Altere a data de levantamento'
          }
          content={
            <React.Fragment>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={"pt"}
                localeText={{
                  cancelButtonLabel: t("cancel"),
                }}
              >
                       
              <DateTimePicker
                dayOfWeekFormatter={(day) => {
                  const map = {
                    "2ª": "S",  // Segunda
                    "3ª": "T",  // Terça
                    "4ª": "Q",  // Quarta
                    "5ª": "Q",  // Quinta
                    "6ª": "S",  // Sexta
                    "Sa": "S",  // Sábado
                    "Do": "D",  // Domingo
                  };
                  return map[day] ?? day;
                }}
                value={dateWithInitialValue}
                onChange={(newValue) => {
                  if(newValue != null){
                    if(newValue.$D){
                      if (
                        new Date(newValue).getTime() > new Date().getTime()
                      ) {
                        setDateWithInitialValue(
                          toLocalISOString(newValue)
                        );
                        setCurrentError(null);
                        setErrorDate(false);
                      } else {
                        setDateWithInitialValue(
                          toLocalISOString(newValue)
                        );
                        setCurrentError(t("validDate"));
                        setErrorDate(true);
                      }
                    }else{
                      setCurrentError(t("validDate"));
                      setErrorDate(true);
                    }
                  }else{
                    setCurrentError(t("validDate"));
                    setErrorDate(true);
                  }
                }}
                label={t("withdrawalDate")}
                
                onError={(reason, value) => {
                  if (reason) {
                    setCurrentError(
                      reason === "maxDate"
                        ? "Donation is expired"
                        : reason
                    );
                    setErrorDate(true);
                  } else {
                    setCurrentError(null);
                    setErrorDate(false);
                  }
                }}
                //disablePast
                minDateTime={dayjs(
                  new Date(donationDetail?.donationId?.donations?.donation?.availableFromDate)
                )}
                maxDateTime={
                  donationDetail?.donationId?.donations?.donation?.isAnimal 
                 // && entity?.entityType === EntityType.specialDistributor
                    ? dayjs(
                        new Date(donationDetail?.donationId?.donations?.donation?.consumeByDate)
                      )
                    : dayjs(new Date(donationDetail?.donationId?.donations?.donation?.expiryDate))
                }
             
                inputFormat="DD/MM/YYYY HH:mm"
                renderInput={(params) => (
               
                    <TextField
                    sx={{mt:4}}
                      {...params}
                      // size="small"
                      error={errorDate}
                      helperText={currentError ?? currentError}
                    />
                  
                  )}
              />
            
            </LocalizationProvider>
            </React.Fragment>
          }
          
          onConfirm={onConfirm}
          
          cancelButtonTitle={t("cancel")}
          confirmButtonTitle={t("confirm")}

          
        />
    </Box>
  );
};

export default Details;
